var name = "@webpd/compiler";
var version = "0.1.0";
var description = "WebPd compiler package";
var main = "./dist/src/index.js";
var types = "./dist/src/index.d.ts";
var type = "module";
var license = "LGPL-3.0";
var author = "Sébastien Piquemal";
var scripts = {
	test: "NODE_OPTIONS='--experimental-vm-modules --no-warnings' npx jest --runInBand --config node_modules/@webpd/dev/configs/jest.js",
	"build:dist": "npx rollup --config configs/dist.rollup.mjs",
	"build:bindings": "npx rollup --config configs/bindings.rollup.mjs",
	build: "npm run clean; npm run build:dist; npm run build:bindings",
	clean: "rm -rf dist",
	prettier: "npm explore @webpd/dev -- npm run prettier $(pwd)/src",
	eslint: "npm explore @webpd/dev -- npm run eslint $(pwd)/src"
};
var repository = {
	type: "git",
	url: "git+https://github.com/sebpiq/WebPd_compiler.git"
};
var bugs = {
	url: "https://github.com/sebpiq/WebPd_compiler/issues"
};
var homepage = "https://github.com/sebpiq/WebPd_compiler#readme";
var devDependencies = {
	"@rollup/plugin-commonjs": "^23.0.4",
	"@rollup/plugin-node-resolve": "^15.0.1",
	"@rollup/plugin-typescript": "^10.0.1",
	"@types/jest": "^29.4.0",
	"@types/node": "^14.14.7",
	"@webpd/dev": "git+https://github.com/sebpiq/WebPd_dev.git",
	assemblyscript: "^0.27.24",
	jest: "^29.4.3",
	rollup: "^3.7.0",
	"ts-jest": "^29.0.5",
	"ts-node": "^10.9.1",
	tslib: "^2.4.1",
	typedoc: "^0.22.17",
	typescript: "^4.7.2"
};
var packageInfo = {
	name: name,
	version: version,
	description: description,
	main: main,
	types: types,
	type: type,
	license: license,
	author: author,
	scripts: scripts,
	repository: repository,
	bugs: bugs,
	homepage: homepage,
	devDependencies: devDependencies
};

export { author, bugs, packageInfo as default, description, devDependencies, homepage, license, main, name, repository, scripts, type, types, version };
